const faqs = [
  {
    q: '51黑料吃瓜网是什么？',
    a: '51黑料吃瓜网是一个专注于娱乐八卦、网红黑料、社会热点事件的在线内容聚合平台。我们提供51吃瓜在线观看、51黑料在线观看、吃瓜在线视频、黑料在线播放等海量免费内容，无需下载即可高清流畅观看。',
  },
  {
    q: '需要下载APP才能看吗？',
    a: '完全不需要！51黑料吃瓜网全面适配手机浏览器，打开网页就能直接观看。无论是51吃瓜在线观看还是黑料在线播放，都无需下载安装任何应用，省流量、省空间。',
  },
  {
    q: '内容更新频率怎么样？',
    a: '我们的编辑团队7×24小时追踪全网热点，确保最新的吃瓜内容在第一时间上线。51黑料吃瓜网每日更新数百条内容，让你永远走在吃瓜第一线，不错过每一个热点。',
  },
  {
    q: '视频播放流畅吗？',
    a: '平台采用先进的视频分发技术，支持高清流畅播放。无论是在WiFi还是移动网络环境下，51吃瓜在线视频和黑料在线播放都能给你流畅的观看体验，并且自动适配网络状况调整清晰度。',
  },
  {
    q: '51黑料吃瓜网的内容来源可靠吗？',
    a: '我们汇聚全网公开信息，由专业编辑团队对各类娱乐八卦、社会热点进行整理和呈现。51黑料吃瓜网致力于为吃瓜群众提供全面、及时的资讯，同时也提醒大家理性吃瓜，不造谣不传谣。',
  },
  {
    q: '如何联系51黑料吃瓜网？',
    a: '你可以通过页面底部的联系方式找到我们。如果你有精彩的吃瓜线索或者想要投稿爆料，欢迎通过51黑料吃瓜网的投稿渠道与我们取得联系，我们的编辑团队会及时处理。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="w-full py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-3xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-3">
            吃瓜常见问题
          </h2>
          <p className="text-sm md:text-base text-foreground-500">
            你想知道的，都在这里
          </p>
        </div>

        <div className="space-y-3 md:space-y-4">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className="bg-background-50 border border-background-200/50 rounded-xl p-5 md:p-6"
            >
              <h3 className="font-heading text-base md:text-lg text-foreground-900 mb-2">
                {faq.q}
              </h3>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                {faq.a}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}